import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { api, errorTreatment } from "../../../../../services/api";
import { ChartPie } from "./chart";
import "../../style.css";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";

export interface Documents {
  data: {
      [propriedade: string]: number;
  };
}

export const ChartDocumentsDeliveredPerSla  = () => {
  const { changeVisibility } = useContext(LoadingContext);
  const { reloadComponent } = useContext(DashboardContext);
  const { shortToken , id, mode } = useParams();
  const { hasShortToken} = useContext(AuthContext);

  let routeDocuments: string;
  const [documents, setDocuments] = useState<Documents["data"]>({});
  const [completeRequisition, setCompleteRequisition] = useState(false);

  if (hasShortToken) {
    routeDocuments = `/documents/delivered?short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeDocuments = `/documents/delivered?screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();
    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    return await api
      .get(routeDocuments)
      .then((documents: Documents) => {
        setDocuments(documents.data);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  return completeRequisition && !reloadComponent ? (
    <div id="chart-documents-delivered-per-sla" className="h100">
      <ChartPie data={documents} />
    </div>
  ) : (
    <></>
  );
};
